import { render, staticRenderFns } from "./RichTextQuote.vue?vue&type=template&id=3ac444dc&scoped=true&"
import script from "./RichTextQuote.vue?vue&type=script&lang=js&"
export * from "./RichTextQuote.vue?vue&type=script&lang=js&"
import style0 from "./RichTextQuote.vue?vue&type=style&index=0&id=3ac444dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac444dc",
  null
  
)

export default component.exports